export default __webpack_public_path__ + "static/media/el4.2734ab29.jpeg";